import Vue from 'vue'
import { $api } from '/libs/services/api'

Vue.mixin({
  computed: {
    $api: () => $api
  }
})